"use strict";
exports.__esModule = true;
exports.updateState = exports.getEventKey = void 0;
function getEventKey(pluginName, eventName) {
    return pluginName + "." + eventName;
}
exports.getEventKey = getEventKey;
function updateState(prevState, newState) {
    return typeof newState === 'function' ? newState(prevState) : newState;
}
exports.updateState = updateState;
